const initialState = {
  socket: null,
};

const socketReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SOCKET_CONNECTED":
      return { ...state, socket: payload };
    case "SOCKET_DISCONNECT":
      return { ...state, socket: null };
    default:
      return state;
  }
};

export default socketReducer;
